'use client';

import {
  Box,
  Card,
  Flex,
  Skeleton,
  Splitter,
  SplitterPanelData,
  useBreakpointValue,
} from '@chakra-ui/react';

const PANELS: SplitterPanelData[] = [
  {
    id: 'home',
  },
  {
    id: 'transfer-cash',
    minSize: 20,
    maxSize: 40,
  },
];
const DEFAULT_SIZE = { base: [60, 40], xl: [70, 30] };

const RedirectionSkeleton = () => (
  <Flex justify="space-between" align="center" p={2} borderRadius="md">
    <Flex align="center" gap={2}>
      <Skeleton boxSize="20px" borderRadius="sm" />
      <Skeleton height="16px" width="100px" borderRadius="sm" />
    </Flex>
    <Flex align="center" gap={2}>
      <Skeleton height="14px" width="80px" borderRadius="sm" />
      <Skeleton boxSize="16px" borderRadius="sm" />
    </Flex>
  </Flex>
);

const PositionsHomePageLoading = () => {
  const size = useBreakpointValue(DEFAULT_SIZE);

  return (
    <Flex w="full" h="full" gap={4}>
      <Splitter.Root panels={PANELS} orientation="horizontal" size={size}>
        <Splitter.Panel id="home">
          <Flex direction="column" gap={4} p={4}>
            {/* ProfitLossCard */}
            <Card.Root
              borderColor="border.light"
              borderRadius="xl"
              bg="surface.background"
              flex={1}
              minW={0}
            >
              <Card.Body p={5} gap={3} justifyContent="space-between">
                <Flex direction="row" justifyContent="space-between" alignItems="flex-start">
                  <Flex direction="column" gap={1}>
                    <Skeleton height="14px" width="80px" borderRadius="sm" />
                    <Skeleton height="36px" width="160px" borderRadius="md" />
                    <Skeleton height="14px" width="80px" borderRadius="sm" />
                  </Flex>
                  <Skeleton height="24px" width="160px" borderRadius="md" />
                </Flex>
                <Skeleton height="60px" borderRadius="md" />
              </Card.Body>
            </Card.Root>

            {/* Redirections */}
            <Flex direction="column" gap={4}>
              <RedirectionSkeleton />
              <RedirectionSkeleton />
            </Flex>

            {/* MarketUpdateSummary */}
            <Box px={2}>
              <Flex direction="column" gap={4}>
                <Skeleton height="20px" width="120px" borderRadius="sm" />
                <Flex direction="column" gap={2}>
                  <Skeleton height="24px" width="280px" borderRadius="md" />
                  <Skeleton height="40px" borderRadius="md" />
                  <Skeleton height="12px" width="50px" borderRadius="sm" />
                  <Skeleton height="40px" borderRadius="md" />
                </Flex>
              </Flex>
            </Box>
          </Flex>
        </Splitter.Panel>
        <Splitter.ResizeTrigger id="home:transfer-cash" hideBelow="lg" disabled>
          <Splitter.ResizeTriggerSeparator bg="border.light" />
        </Splitter.ResizeTrigger>
        <Splitter.Panel id="transfer-cash" hideBelow="lg">
          <Flex direction="column" p={5} gap={5} h="full">
            <Skeleton height="28px" width="180px" borderRadius="md" />
            <Skeleton height="60px" borderRadius="md" />
            <Flex direction="column" gap={0}>
              <Flex alignItems="center" gap={3} p={3}>
                <Skeleton boxSize="40px" borderRadius="full" />
                <Flex direction="column" gap={1} flex={1}>
                  <Skeleton height="14px" width="60px" borderRadius="sm" />
                  <Skeleton height="12px" width="140px" borderRadius="sm" />
                </Flex>
              </Flex>
              <Box w="2px" h="20px" bg="border.light" ml="31px" />
              <Flex alignItems="center" gap={3} p={3}>
                <Skeleton boxSize="40px" borderRadius="full" />
                <Flex direction="column" gap={1} flex={1}>
                  <Skeleton height="14px" width="80px" borderRadius="sm" />
                  <Skeleton height="12px" width="120px" borderRadius="sm" />
                </Flex>
              </Flex>
            </Flex>
            <Skeleton height="32px" borderRadius="md" />
          </Flex>
        </Splitter.Panel>
      </Splitter.Root>
    </Flex>
  );
};

export default PositionsHomePageLoading;
